import { isValid } from 'date-fns';
import { fmt, zoned } from '@/utils/dates';
import type { Period } from '../store/store';
import type { CustomDateRange } from '../util';

const formatPeriodDisplayName = (date: CustomDateRange | null) => {
  if (!date?.from || !isValid(date.from)) return undefined;

  if (date.to && isValid(date.to)) {
    return `${fmt(date.from, 'LLL dd, y')} - ${fmt(date.to, 'LLL dd, y')}`;
  }

  return fmt(date.from, 'LLL dd, y');
};

// Treat yyyy-MM-dd as a calendar day in the TZ.
const toLocalDate = (date: string) => (date ? zoned(`${date}T00:00:00`) : undefined);

const formatPeriod = (period: Period, periodSelect: Record<string, CustomDateRange>) => {
  const base = periodSelect[period.periodSlug];
  if (!base) return null;

  if (period.periodSlug === 'custom') {
    return {
      ...base,
      from: toLocalDate(period.start),
      ...(period.end ? { to: toLocalDate(period.end) } : {}),
    };
  }

  return base;
};

export { formatPeriod, formatPeriodDisplayName };
